var oldValue = 0;
var newValue = 0;
(function(){
var finished;
var deviceScroll = 0;
    var Magik_Infinite_JavaScript = function(jQuery)  {
        /* Your app's JavaScript here.
             $ in this scope references the jQuery object we'll use.
             Don't use 'jQuery', or 'jQuery191', here. Use the dollar sign
             that was passed as argument.*/

        // var $ = jQuery.noConflict(); 
        var shop_domain = Shopify.shop; 
        var host = "https://infinitescroller.magikcommerce.com"; 
        var api_url = host + "/get_setting";

        var navSelector     = ".pagination,.pagination-custom,.pagination-page"; 
        var nextSelector    = ".pagination .pagination-next a,.pagination span:last-child a,.pagination li:last-child a,.pagination-custom li:last-child a,.pagination-custom span:last-child a,.pagination-page li:last-child a,.pagination a.pagination__btn:last-child";
        var contentSelector = ".collection-product-list .grid-x,.grid--uniform,.grid-uniform,.grid.grid__item,.products-listing,.grid-collage,.card-list.grid";
        var itemSelector    = ".collection-product-item,.grid__item,.grid-item,.grid_item,div.product,.card";
        var itemclass       = "";
        var loader          =  host+"/assets/images/mgk-loader.gif";
        var loader_img_position = "";
        jQuery(navSelector).hide();
        jQuery('div.collection-result-pagination').hide();
        var loading_height = 400 ;
        var is_extra_integration_needed = 0 ;
        var integration_code = "" ;
        var device;
        var mgk_infinite_scroll = 0; 
        var default_next_page = 0; 
        // code for open product in new tab
        var open_products_in_new_tab = 0;
        var resultJ = {"status":"success","site_settings":{"id":"6186","site_id":"6186","account_id":"6193","is_scrolling_enabled":"1","nav_selector":null,"next_selector":null,"content_selector":null,"item_selector":null,"item_class":null,"loader_img_url":null,"file_name":null,"inline_js_version":"1.0","script_version":"1.0","is_default_setting":"1","loading_height":"0","loader_img_position":null,"is_extra_integration_needed":"0","integration_code":null,"open_products_in_new_tab":"0","created_at":"2022-07-27 11:28:22","updated_at":"2022-07-27 11:47:58"}};
        // console.log("result", resultJ );
        jQuery.ajax({
            url: api_url,
            type: "POST",                      
            data: "shop_domain="+shop_domain,                     
            success: function (result)  
            {    
                var result = jQuery.parseJSON(result); 
                result = resultJ;
                  
                if(result.status = "success") {
                    site_settings = result.site_settings;
                    is_default_setting = result.is_default_setting;
                                   
                    if(site_settings) {
                        if(site_settings.nav_selector && is_default_setting != 1) {
                            // navSelector     = navSelector+","+site_settings.nav_selector;
                            navSelector     = site_settings.nav_selector;
                           // console.log("navSelector", navSelector);
                        } 

                        if(site_settings.next_selector && is_default_setting != 1) {
                            // nextSelector    = nextSelector+","+site_settings.next_selector;
                            nextSelector    = site_settings.next_selector;

                        }

                        if(site_settings.content_selector && is_default_setting != 1) {
                            // contentSelector = contentSelector+","+site_settings.content_selector;
                            contentSelector = site_settings.content_selector;

                        }

                        if(site_settings.item_selector && is_default_setting != 1) {
                            // itemSelector    = itemSelector+","+site_settings.item_selector;
                            itemSelector    = site_settings.item_selector;
                        }

                        if(site_settings.item_class && is_default_setting != 1) {
                            // itemclass    = itemclass+","+site_settings.itemclass;
                            itemclass    = site_settings.item_class;
 
                        }
                        
                        
                        if(site_settings.loader_img_url) {
                            loader          = site_settings.loader_img_url;
                        }

                        if(site_settings.loader_img_position)
                        {
                            loader_img_position          = site_settings.loader_img_position;
                        }

                        if(site_settings.loading_height != 0)
                        {
                            loading_height          = site_settings.loading_height;
                        }

                        if(site_settings.is_extra_integration_needed != 0)
                        {
                            is_extra_integration_needed    = site_settings.is_extra_integration_needed;
                        }

                        if(site_settings.integration_code )
                        {
                            integration_code          = site_settings.integration_code;
                        }

                        if(site_settings.open_products_in_new_tab )
                        {
                            open_products_in_new_tab          = site_settings.open_products_in_new_tab;
                        }
                        // console.log("site_settings.is_scrolling_enabled", site_settings.is_scrolling_enabled);
                        mgk_infinite_scroll = site_settings.is_scrolling_enabled;  
                        get_infinite_scroller(mgk_infinite_scroll,navSelector,nextSelector,contentSelector,itemSelector,itemclass,loader,loading_height,loader_img_position,is_extra_integration_needed,integration_code, open_products_in_new_tab);

                        
                    } 
                     
                }
            } 
        }); 

      	
      var filter_url = false;
        function  get_infinite_scroller(mgk_infinite_scroll,navSelector,nextSelector,contentSelector,itemSelector,itemclass,loader,loading_height,loader_img_position,is_extra_integration_needed,integration_code,open_products_in_new_tab, filter_url)
        {
             //console.log("scroller status:" + mgk_infinite_scroll);
             //console.log("loading_height:"+loading_height);

            if(mgk_infinite_scroll==1 )  {
                
                // code for open product in new tab
                if(open_products_in_new_tab == 1) {
                    jQuery(contentSelector).find("a").attr("target","_blank"); 
                }
                
                var loading  = false;
                finished = false;
                // console.log("nextSelector test:"+nextSelector);
                jQuery(nextSelector).addClass("next");
                var next_page_url  = jQuery(nextSelector).attr('href'); // init next url
                default_next_page = next_page_url;
                // console.log("next_page_url:"+next_page_url);  
                // console.log("nextSelector:"+jQuery(nextSelector).length);
                // console.log("navSelector:"+jQuery(navSelector).length);

                // console.log("itemSelector:"+jQuery(contentSelector+" "+ itemSelector).length);

                // console.log("contentSelector:"+jQuery(contentSelector).length); 
                // console.log(jQuery(".grid-uniform").length); 
                // console.log("contentSelector1:"); 
                 
                // console.log(jQuery(contentSelector).not(contentSelector1).length);
             
                contentSelector1 = "footer .grid-uniform,aside .grid-uniform";

 

                if( jQuery(nextSelector).length && jQuery(navSelector).length && jQuery(contentSelector+" "+ itemSelector).length && jQuery(contentSelector).length) {
                     
                    // console.log("in if "+navSelector);
                    jQuery(navSelector).hide();
                    jQuery('div.collection-result-pagination').hide();
                    if(loader)  {
                        // console.log("loader_img_position:"+loader_img_position);
                        if(loader_img_position) {
                            // console.log("in if");
                            eval(loader_img_position);
                        } else {
                            // console.log("in else"); 
                          if(!jQuery('.magik-infi-loader').length){
                            jQuery(contentSelector).not(contentSelector1).eq(0).after( '<div class="magik-infi-loader" style="display:inline-block;width:100%;text-align:center;margin-top:15px; margin-bottom: 20px;"><img src="' + loader + '"  style="display:inline-block;" alt="Loading more images. Please wait."></div>' ); 
                          }
                        }
                    }          

                } else { 
                    // console.log("-----------in else"); 

                    jQuery(navSelector).show();
                   // jQuery(navSelector).css("display","inline-block");
                    finished = true;

                } 
               
         
                var magik_infinite_scrolling = function (dnext_page_url, filter_url) {
                    jQuery('div.collection-result-pagination').hide();
                    var page_last_element   = jQuery(contentSelector).not(contentSelector1).eq(0).find(itemSelector).last();
                     // console.log("dnext_page_url magik_infinite_scrolling", dnext_page_url);

                  
                    loading = true;
                    let scrollToBottom = (ele) => {
                      setTimeout( function() {  
                        ele.scrollIntoView(false);
                      },300);
                    };
                    if(!finished && loader) {
                      if(!document.querySelectorAll('.magik-infi-loader').length){
                          jQuery(contentSelector).not(contentSelector1).eq(0).after( '<div class="magik-infi-loader" style="display:inline-block;width:100%;text-align:center;margin-top:15px; margin-bottom: 40px;"><img src="' + loader + '"  style="display:inline-block;" alt="Loading more images. Please wait."></div>' ); 
                       }  
                      const element = document.querySelectorAll('.magik-infi-loader')[0];
                      console.log("Scroll Bottom");
                      scrollToBottom(element);
                    }
                  
                    // console.log("show"); 
                    jQuery('.magik-infi-loader').show();
                   if(filter_url) {
                     next_page_url = dnext_page_url;
                     filter_url = false;
                     if(!jQuery('.magik-infi-loader').length){
                        jQuery(contentSelector).not(contentSelector1).eq(0).after( '<div class="magik-infi-loader" style="display:inline-block;width:100%;text-align:center;margin-top:15px;"><img src="' + loader + '"  style="display:inline-block;" alt="Loading more images. Please wait."></div>' ); 
                     }
                     jQuery('div.collection-result-pagination').hide();
                   }

                    next_page_url = decodeURIComponent(next_page_url);
                    next_page_url = next_page_url.replace(/^(?:\/\/|[^\/]+)*\//, "/");
                    // console.log("next_page_url:"+next_page_url);
                   
                    if( next_page_url == '' || (next_page_url.indexOf("javascript") > -1) || (next_page_url == "#") || (next_page_url == "undefined") ) { 
                        // console.log("hide", ' filter_url: ', filter_url);
                        jQuery('.magik-infi-loader').hide();  
                        finished = true;
                        loading = false;   
                    } else {
                        setTimeout( function() {                               
                            jQuery.ajax({

                                    url         : next_page_url,
                                    dataType    : 'html',
                                    cache       : false,
                                    success     : function (data) 
                                    {
                                      

                                        
                                        var obj         = jQuery(data);
                                      //   console.log("obj-----: next_page_url", next_page_url);
                                      // console.log(obj);
                                       
                                        new_elements    = obj.find(contentSelector).not(contentSelector1).eq(0).html();
                                        next_elements   = obj.find(nextSelector);
                                        current_url     = next_page_url;
                                       
                                      //  console.log("new_elements current_url", current_url);
                                      // console.log(new_elements);
                                      //  console.log("new_elements1");
                                      // console.log('next_elements', next_elements);
                                        

                                        if( next_elements.length )  {
                                            next_page_url = next_elements.attr( 'href' );
                                          
                                        } else {
                                            finished = true;
                                        }                     
                                            // console.log("outside itemclass");

                                        
                                      console.log("next_page_url :", next_page_url, 'finished :', finished);
                                      
                                       if(itemclass) {
                                        // console.log("inside itemclass:"+itemclass);
                                           
                                            new_elements = $(new_elements);
                                            // console.log("new_elements:");
                                            // console.log(new_elements);
                                            new_elements.each(function () 
                                            {
                                                // console.log("in each");
                                                var t = jQuery(this);
                                                // t.removeClass(t.attr('class'));

                                                t.addClass(itemclass); 
                                            });
                                            // new_elements.find(itemSelector).addClass(itemclass);
                                      }

                                        page_last_element.after( new_elements );

                                        jQuery(contentSelector+" .grid__item").find(".pagination").parent().replaceWith("");  

                                        // code for open product in new tab
                                        if(open_products_in_new_tab == 1) {
                                            jQuery(contentSelector).find("a").attr("target","_blank"); 
                                        }
                
                                        if(is_extra_integration_needed == 1 && integration_code) {
                                            eval(integration_code); 
                                        }
                                        // if(jQuery(itemSelector+" div.pagination").length > 0 )
                                        // {
                                        //     console.log("exist");
                                        //     jQuery(itemSelector+" div.pagination").parent().replaceWith("");
                                        // }
                                        // jQuery("div.pagination").replaceWith("");
                                        
                                        // jQuery("div.pagination").parent().replaceWith("");

                                        loading = false;                    
                                        //console.log("hide");  

                                        jQuery('.magik-infi-loader').hide();
                                    }
                                });
                        }, 600);
                    };
                    /*let scrollToBottom = (ele) => {
                      setTimeout( function() {  
                        ele.scrollIntoView(false);
                      },300);
                    };
                    if(!finished && loader) {
                      const element = document.querySelectorAll('.magik-infi-loader')[0];
                      console.log("Scroll Bottom");
                      scrollToBottom(element);
                    }*/
                  
                }; 

                   // set event
                    jQuery( window ).on( 'scroll touchstart', function () {
                         //set scroll position in session storage
                        jQuery(this).trigger('magik_scroll_start');
                    }); 

                    // set event Clicks
                    var arr2 = jQuery('div.filter-result div.filterresult-wrap').find();
                    var sectorArray = jQuery('li.collection-filter-list a');
                    var filterArray = [];
                    var deleteAll = [];
                 
                    var addfilterTriggers = function(ele,typeEle) {
                      var eleArray = document.querySelectorAll(ele);
                        if(eleArray.length > 0) {
                            jQuery.each(eleArray, function (i, filter) {
                              //console.log("eleArray type:", ele, this, 'length', eleArray.length);
                               jQuery(filter).on("click", function (e) { 
                                  magik_infinite_scrolling_filter(false, device);
                                 setTimeout( function() { 
                                    eleArray = document.querySelectorAll(ele);
                                    if((eleArray.length == 0 && typeEle == 'filter')  || ((eleArray.length % 2) == 0 && typeEle == 'all')) {
                                        thereIsFilter = false;
                                        console.log(thereIsFilter);
                                        localStorage.setItem('thereIsFilters', thereIsFilter);
                                    };
                                 },1000);
                               });
                            });     
                        };
                        if(typeEle == 'filter') {
                         filterArray = eleArray;
                        };
                    };
              
                    var thereIsFilter = localStorage.getItem('thereIsFilters') || false; 
                    
                    if(thereIsFilter) {
                      setTimeout( function() { 
                         // console.log('filterArrays', filterArray);
                         addfilterTriggers('[data-collection-filter-result-remove]', 'filter');
                      },1000);                      
                    };

                    var magik_applay_tirgger = function() {
                      var eleArray = document.querySelectorAll('[data-collection-apply]');
                      if(eleArray.length > 0) {
                            jQuery.each(eleArray, function (i, apply) {
                               jQuery(apply).on("click", function (e) { 
                                  magik_infinite_scrolling(default_next_page, true); 
                               });
                            });     
                        };
                    };
              
                    var magik_infinite_scrolling_filter = function (typeClick, device) {
                       setTimeout( function() { 
                         default_next_page = window.location.href.replace('?constraint=', '/').split('.com')[1] + "?page=2";
                         console.log("default_next_page 1500", default_next_page);
                         if (device == "desk") {
                            magik_infinite_scrolling(default_next_page, true);  
                         } else {
                            magik_applay_tirgger();
                         }
                         
                         finished = false;
                         jQuery("html, body").animate({
                            scrollTop: '60px'
                         }, 500);
                         
                         if(typeClick) {
                            thereIsFilter = true;
                            localStorage.setItem('thereIsFilters', thereIsFilter);
                            addfilterTriggers('[data-collection-filter-result-remove]', 'filter');
                            addfilterTriggers('[data-collection-clear-all]', 'all');
                         };
                         if(!jQuery('.magik-infi-loader').length){
                           console.log('.magik-infi-loader', jQuery('.magik-infi-loader').length);
                            jQuery(contentSelector).not(contentSelector1).eq(0).after( '<div class="magik-infi-loader" style="display:inline-block;width:100%;text-align:center;margin-top:15px;"><img src="' + loader + '"  style="display:inline-block;" alt="Loading more images. Please wait."></div>' ); 
                         }
                         
                       },1200);

                    };
              
                      // sectorArray[sectorArray.length] = arr2[0];
                      // console.log("sectorArras arr2", arr2);
                      jQuery.each(sectorArray, function (i, sector) {
                          jQuery(sector).on("click", function (e) { 

                            if(jQuery(window).width() > 800) {
                                 console.log("window > 801 Desktop");
                                 device = "desk";
                                 deviceScroll = 120;
                                 magik_infinite_scrolling_filter(true, device);
                            } else {
                                 device = "mb";
                                 deviceScroll = 570;
                                 magik_infinite_scrolling_filter(true, device);
                                 console.log("window < 800 Mobile");
                            };
                              
                          });
                      });


          
                    jQuery( window ).on( 'magik_scroll_start', function()  {
                        var t          = jQuery(this),
                        last_element   = jQuery(itemSelector).last();

                      
                        if( typeof last_element == 'undefined' ) {
                            return;
                        }
             
                        if ( ! loading && ! finished && ( t.scrollTop() + t.height() ) >= ( last_element.offset().top + last_element.height() - loading_height ) )  {
                            magik_infinite_scrolling(next_page_url, false);
                        }
                    });
                     
            } else {
                jQuery(navSelector).show();
                //jQuery(navSelector).css("display","inline-block");
            }
        }
    };
  let maxScroll;
if(window.screen.width > 800) {
    deviceScroll = "desk";
    maxScroll =500;
} else {
     deviceScroll = "mb";
     maxScroll = 600;
};


  
let oldeleOffsetTop; 
let footerHeight;  
window.addEventListener('scroll', (e) => {
  newValue = window.pageYOffset;
ele = document.querySelector('.layout-footer');


/*  if (oldValue < newValue) {
    let marginScroll = window.scrollMaxY - window.scrollY;    
    let eleOffsetTop = ele.offsetTop || oldeleOffsetTop;
    footerHeight = document.body.scrollHeight - eleOffsetTop;
    let screenDevice = window.screen.height;
    let marginScrollEle =  (window.scrollY - (eleOffsetTop - screenDevice));

    if (eleOffsetTop > 0) {
      
      oldeleOffsetTop = eleOffsetTop;
      let y = +(eleOffsetTop - (screenDevice - 50));
      if (marginScrollEle < 200 && marginScrollEle > 0) {
        
        if(!finished) {
          console.log("marginScrollEle", marginScrollEle, '||', eleOffsetTop, "|| window.scrollY", window.scrollY, "|| window.scrollMaxY", document.body.scrollHeight, "||y", y);
          window.scrollTo({
            top: y,
            behavior: 'smooth'
          });
        } 
      }
      if(!finished && (marginScrollEle  <= 1 && marginScrollEle  > -10) ) {
         window.scrollTo({
          top: y,
          behavior: 'smooth'
        });
      }
      if(!finished) {         
          if(!document.querySelectorAll('.magik-infi-loader').length){
              jQuery(contentSelector).not(contentSelector1).eq(0).after( '<div class="magik-infi-loader" style="display:inline-block;width:100%;text-align:center;margin-top:15px; margin-bottom: 40px;"><img src="' + loader + '"  style="display:inline-block;" alt="Loading more images. Please wait."></div>' ); 
           }          
      } 
    }
  }

  oldValue = newValue;*/

});


  
    var loadScript = function(url, callback)  {
        var script = document.createElement("script");
        script.type = "text/javascript";

          // If the browser is Internet Explorer.
        if (script.readyState){ 
            script.onreadystatechange = function(){
              if (script.readyState == "loaded" || script.readyState == "complete"){
                script.onreadystatechange = null;
                callback();
              }
            };
          // For any other browser.
        } 
        else 
        {
            script.onload = function()
            {
                callback();
            };
        }

        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
   };
  

    if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
      loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function(){
        jQuery191 = jQuery.noConflict(true);
        Magik_Infinite_JavaScript(jQuery191);
      });
    } else {
      Magik_Infinite_JavaScript(jQuery);
    }
    
})();

